
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[[...index]]",
      function () {
        return require("private-next-pages/services/[[...index]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/[[...index]]"])
      });
    }
  